import { Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import React from 'react';

export interface IFormulaireProps {
    valueGF: any;
    setValueGF: any;
}

const FormulaireGroupeFonctionnalite = (props: IFormulaireProps) => {


    const {
        valueGF, setValueGF
    } = props


    return (
        <div>
            <Grid container spacing={2}>
                <Grid item md={12} xs={12} sm={12}>
                    <TextField
                        label="Groupe fonctionnalité"
                        fullWidth
                        required
                        margin="dense"
                        size="small"
                        type="text"
                        variant="standard"
                        name="valueGF"
                        value={valueGF}
                        onChange={(e) => setValueGF(e.target.value)}
                    />
                </Grid>
            </Grid>
        </div>
    );
}
export default FormulaireGroupeFonctionnalite;
